module.exports = __webpack_public_path__ + "static/img/bgi.6fabcb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/bgi.jpg
// module id = 679
// module chunks = 1